module.exports = __webpack_public_path__ + "static/img/c0.6978222.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slwh/c0.png
// module id = XNRS
// module chunks = 0